// Quietly attempts the browser Geolocation API. Returns null on failure so callers don't break.
// highAccuracy=true is critical for SOS - the network-based (cell tower) fix
// is often off by kilometers, useless for family trying to reach you.
export function getCurrentLocation(timeoutMs = 4000, highAccuracy = false) {
  return new Promise((resolve) => {
    if (!navigator.geolocation) return resolve(null);
    let done = false;
    const finish = (val) => { if (!done) { done = true; resolve(val); } };
    setTimeout(() => finish(null), timeoutMs);
    navigator.geolocation.getCurrentPosition(
      (pos) => finish({ lat: pos.coords.latitude, lng: pos.coords.longitude, accuracy: pos.coords.accuracy }),
      () => finish(null),
      { enableHighAccuracy: highAccuracy, maximumAge: 60000, timeout: timeoutMs }
    );
  });
}

export function getBatteryLevel() {
  return new Promise((resolve) => {
    if (!navigator.getBattery) return resolve(null);
    navigator.getBattery().then(
      (b) => resolve(Math.round((b.level || 0) * 100)),
      () => resolve(null),
    );
  });
}

export function vibrate(pattern) {
  try { navigator.vibrate && navigator.vibrate(pattern); } catch {}
}

export function timeAgo(iso) {
  if (!iso) return "";
  const d = new Date(iso);
  const sec = Math.floor((Date.now() - d.getTime()) / 1000);
  if (sec < 60) return "just now";
  const min = Math.floor(sec / 60);
  if (min < 60) return `${min}m ago`;
  const hr = Math.floor(min / 60);
  if (hr < 24) return `${hr}h ago`;
  const day = Math.floor(hr / 24);
  if (day < 7) return `${day}d ago`;
  return d.toLocaleDateString("en-IN", { day: "numeric", month: "short" });
}

export function formatDateLong() {
  return new Date().toLocaleDateString("en-IN", {
    weekday: "long", day: "numeric", month: "long"
  });
}
